import { isFeatureEnabled } from 'owa-feature-flags';

export function shouldCommandingStretchLeft(): boolean {
    return isFeatureEnabled('mon-ribbon') || isFeatureEnabled('mon-ribbon-cal-aboveLeftNav');
}
